export default __webpack_public_path__ + "static/media/suspension.534c6a7e.svg";